export const styleDefaults = {
  fontFamily: 'OpenSans',
  fontSize: 11,
  fontColor: '#000000',
  backgroundColor: '#ffffff',
  backgroundColorOpacity: 1,
  horizontalAlignment: 'center',
  verticalAlignment: 'center',
  lineHeight: 1.25,
  fontStyle: 'normal',
  fontWeight: 400,
  textDecoration: 'none',
}
